import useEventStore, { agendas, events } from '../../stores/eventStore';
import styles from './agendaForm.module.scss';
import { AgendaFormItem } from './AgendaFormItem';


export const AgendaForm = () => {
	const { activeTab } = useEventStore();
	const event = events.find((e) => e.topic === activeTab);
	const group = agendas.find((e) => e.topic === activeTab);
	const agendaData = group?.items || [];

	return (
		<div className={styles.agendaForm}>
			<div className={styles.title}>
				<img
					className={styles.titleImage}
					src={event.titleImage}
					alt='[ 護心同行：安穩跳動，自在生活 ]'
				/>
			</div>
			<div className={styles.agendaTitle}>
				<span>精彩議程</span>
			</div>
			<div className={styles.agendaWrapper}>
				<div className={styles.agendaHeaderContainer}>
					<div className={styles.agendaHeader}>
						<div className={styles.agendaHeaderPlace}>
							<b>地點</b>
						</div>
						<div className={styles.agendaHeaderAddress}>
							<b>政大公企中心 10F A1034 會議教室</b>
							<br className='d-lg-none' /> (台北市大安區金華街 187 號)
						</div>
					</div>
				</div>
        <AgendaFormItem items={agendaData} />
			</div>
		</div>
	);
};
